import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import BirthDateInput from './BirthDateInput';

loadDOMComponent({
	selector: 'react-birth-date-input',
	callback: ({ container }) => {
		const value = container.getAttribute('value');
		const id = container.getAttribute('data-target-hidden-id');

		const handleChange = value => {
			const element = document.querySelector("[data-hidden-id='" + id + "']");
			// @ts-ignore
			element.value = value;
		};

		ReactDOM.render(
			<AppContextProvider>
				<BirthDateInput onChange={handleChange} value={value} />
			</AppContextProvider>,
			container,
		);
	},
});
